import compact from 'lodash/compact';
import sumBy from 'lodash/sumBy';
import routineLogo from 'assets/images/short-lighto-logo.png';
import {
  differentLabelChannels,
  formatDateTime,
  formatMoney,
  getTotalQuantiy,
} from 'utils/formattedString';
import { DynamicObjectType } from 'types/commons';
import { LOGISTICS } from 'constants/constants';
import { formatDateStr } from 'core/helper/formatString';

export const genBoxmeLabel = (order) => {
  return `<section style="position:relative;">
<div style="width: 10cm; height: 15cm; overflow: hidden; text-overflow: ellipsis; font-size: 12px; border:1px solid #000; border-radius: 20px; ">
   <div style="padding: 10px 0;">
    <div style="margin-right: 5px;height: 60px;width: 60px; min-width: 60px; display: inline-block">
    <img src="${
      order?.chainStore?.logo || routineLogo
    }" style="width: 100%; height: 100%; object-fit: contain; filter: brightness(0);" /></div>
      <div style="width: 230px; text-align: left;font-size: 11px; flex-grow: 2;display: inline-block;">
         <div style="line-height: 12px;">
            <strong>${order?.chainStore?.name || 'routine'} Vietnam (${
              order?.chainStore?.siteUrl || 'routine.com.vn'
            })</strong> | ${
              order?.chainStore?.data?.companyName ||
              'CÔNG TY TM DV TỔNG HỢP HOÀN VŨ'
            } | ${
              order?.chainStore?.data?.address ||
              '294 Hai Bà Trưng, P. Tân Định Q1, TP.HCM'
            }</div>
      </div>
      <div style="height: 60px;width: 50px; min-width: 50px; display: inline-block;">
      <img width="50px" src="${
        order?.partner?.data?.thumbnail
      }" style="width: 100%; height: 100%;object-fit: contain; filter: brightness(0);" /></div>
   </div>
   <div style="width: 100%; border-top: 1px solid #000;">
     <div >
        <div style="display: inline-block;width: calc(10cm - 136px); text-align:left; padding: 0px; font-size: 9px;">
           <div style="padding: 0">
              <div style="width: 74%; display: inline-flex;font-size: 8px; text-align:left; padding-left: 5px;">
              <img width="50px" height="50px" src="${`http://api.qrserver.com/v1/create-qr-code/?data=${order?.orderNumber}&size=500x500`}" />
           </div>
           ${
             order?.sortCode
               ? `<div style="width: 25%;display: inline-flex;font-size: 8px; text-align:left;">
           <img width="50px" height="50px" src="${`http://api.qrserver.com/v1/create-qr-code/?data=${order?.sortCode}&size=500x500`}" />
           
        </div>`
               : ''
           }
           
           </div>

          <div style="text-align:left; padding: 0px; font-size: 9px;">
            <div style="font-size:13px; padding-left: 5px; font-weight:800;width: 100%; display: flex; justify-content: space-between; padding-right:5px;">
            <span style="display: inline-block;width: 74%;">${
              order?.orderNumber
            }</span> ${
              order?.sortCode
                ? `<b style="font-size:9px;font-weight: 600;">
            ${order?.sortCode}
         </b>`
                : ''
            } 
            </div>
          
      </div>
        </div>
        <ul style="display: inline-block;min-width: 130px;width: 130px; list-style: none; padding-left: 0px; border-left: 1px solid #000; text-align:left; font-size: 8px; line-height: 11px;height: 82px;">
            <li style='padding-left: 5px;'>• Không đồng kiểm</li>
            <li style='padding-left: 5px;'>• <span style="font-weight: 600;text-transform: uppercase;">Vui lòng quay phim khi mở hàng</span></li>
            <li style='padding-left: 5px;'>• Một số sản phẩm có thể không thể hiện rõ do danh sách quá dài</li>
            <li><div style="font-size:10px;"><i>Thu COD: </i><b>${
              order?.payments?.find((e) => e.type === 'cod') ||
              order?.paymentType === 'cod'
                ? formatMoney(
                    order?.payments?.length > 0
                      ? sumBy(
                          order?.payments?.filter((e) => e.type === 'cod'),
                          (e: DynamicObjectType) => +e.amount,
                        )
                      : order?.total,
                    undefined,
                    undefined,
                    ' ',
                  )
                : 0
            } VND</b></div></li>
        </ul>
     </div>
     <div style="border-top: 1px solid #000;">
     <div  style="padding: 2px 5px;font-size: 8px; text-align:left; flex:2;">
       <div style="font-size: 9px; line-height: 11px;">
       Người nhận: <b>${[
         `${order?.address?.firstName || ''} ${order?.address?.lastName || ''}`,
         compact([
           order?.address?.addressLine1,
           order?.address?.addressLine2,
           order?.address?.ward,
           order?.address?.district,
           order?.address?.province,
         ]).join(', '),
         order.address?.telephone,
       ].join(' | ')}</b>
       </div>
       ${
         order?.address?.what3words
           ? `<div style="display:flex; align-items:center;">
           <img height="15px" style="margin-right: 10px; margin-top: 2px;" src="https://res.cloudinary.com/hsv-search-image/image/upload/v1666241387/w3wlogo2_lkhs2l.png" />
       /// ${order?.address?.what3words}
       </div>`
           : ''
       }
    </div>
     </div>
    <div style="border-top: 1px solid #000;">

    <div style="border-right: 1px solid #000;display:inline-block; width: calc(10cm - 136px);">
    <div style="text-align: left;">
     <canvas style="height: 55px;"  id="customer-order-id-${
       order?.id
     }"></canvas>
     <div><b style="font-size:13px; margin-left: 5px;">${
       order?.deliveryCode
     }</b></div>
       </div>
    </div>

    <div style=" padding: 2px 0px; padding-left: 3px;text-align:left; display: inline-block; width: 130px;">
    <b style="font-size: 9px;">Chữ ký khách hàng</b>
 </div>
    </div>
      
      <div  style="text-align: left; border-top:1px solid #000; padding: 6px 10px;
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: 14px; max-height: 175px;">
         <div style="font-size:10px;">
            <div style="display: inline-block; width: 50%;">
            <span>Tổng số lượng sản phẩm:</span> <b>${getTotalQuantiy(
              order?.items,
            )}</b></div>
            <div style="display: inline-block; width: 49%; text-align: right;"><span>Ngày xử lý đơn:</span> <span style="font-size: 11px;font-weight: 600;">${formatDateStr(
              order?.updatedAt,
            )}</span></div>
            
            
            </div>
         <div>
            <div style="
            overflow: hidden;
            text-overflow: ellipsis;
            line-height: 14px;
        ">
            ${order?.items
              ?.map(
                (e, index) =>
                  `<div>${index + 1}. ${compact([
                    e?.product?.productType?.detail?.find(
                      (e) => e?.langCode === 'vi',
                    )?.name ||
                      e?.product?.productType?.detail?.find(
                        (e) => e?.langCode === 'en',
                      )?.name ||
                      e?.product?.productType?.slug ||
                      '',
                    e.product?.detail?.[0]?.name,
                    e?.ItemDescription,
                    e?.VariantId,
                    e?.variantSku,
                  ]).join(', ')} x ${e.quantity}</div>`,
              )
              ?.join('')}
            </div>
         </div>
      </div>
               
      </div>
   </div>
   
   
</div>
</section>`;
};

export const genLargeLabelPackage = (order) => {
  return new Promise((resolve) =>
    resolve(
      differentLabelChannels.includes(order?.channel) ||
        differentLabelChannels.includes(order?.shippingCarrier?.name)
        ? getLabel(order)
        : `<section style="position:relative;">
<div style="width: 10cm; height: 15cm; overflow: hidden; text-overflow: ellipsis; font-size: 12px; border:1px solid #000; border-radius: 20px; display: flex;
 flex-direction: column;">
   <div style="display:flex;padding: 10px;  justify-content: space-between; gap: 10px">
    <div style="width: 60px; min-width: 60px; display: flex; align-items: center">
    <img src="${
      order?.chainStore?.logo || routineLogo
    }" style="width: 100%; object-fit: contain; filter: brightness(0);" /></div>
      <div style="text-align: left;font-size: 11px; flex-grow: 2;display:flex; align-items:flex-start; flex-direction:column; justify-content:center;">
         <div style="line-height: 12px;">
          <div><strong>${order?.chainStore?.name || 'routine'} Vietnam (${
            order?.chainStore?.siteUrl || 'routine.com.vn'
          })</strong>
          </div>
          <div style="font-size: 9px;">${
            order?.chainStore?.data?.companyName ||
            'CÔNG TY TM DV TỔNG HỢP HOÀN VŨ'
          }
          </div>
          <div style="font-size: 9px;">${
            order?.chainStore?.data?.address ||
            '294 Hai Bà Trưng, P. Tân Định Q1, TP.HCM'
          }
          </div>
          ${
            order?.chainStore?.data?.hotline
              ? `
            <div style="font-size: 9px;">Hotline: ${order?.chainStore?.data?.hotline}</div>
          `
              : ''
          }
        </div>
      </div>
      <img width="50px" src="${
        order?.partner?.data?.thumbnail
      }" style="object-fit: contain; filter: brightness(0);" />
   </div>
   <div style="display:flex; flex:1; flex-direction:column; padding-top: 2px; width: 100%; border-top: 1px solid #000;">
     <div style="display:flex;">
        <div style="flex:2; text-align:left; padding: 0px; justify-content: space-between; font-size: 9px;">
           <div style="padding: 0 3px 2px; display:flex;">
              <canvas style="height: 55px;" id="sale-order-id-${
                order?.id
              }"></canvas>
              <div style="width: 25%;display:flex; flex-direction: column; justify-content:center;  align-items:center;flex:1;font-size: 8px; text-align:left;">
              <canvas class="order-qrcode-img" id="qr-ordernumber-${order?.id}"></canvas>
           </div>
           </div>

          <div style="text-align:left; display:flex; padding: 0px; justify-content: space-between; font-size: 9px;">
          <div style="flex:1; padding: 0 3px 2px;">
            <div style="font-size:13px; padding-left: 5px; font-weight:800;width: 100%; display: flex; justify-content: space-between; padding-right:10px;">${
              order?.id
            }  <b>${order?.orderNumber}</b></div>
          </div>
          
      </div>
        </div>
        <ul style="width: 130px; list-style: none; padding-left: 0px; border-left: 1px solid #000; text-align:left; font-size: 8px; line-height: 11px;">
            <li style='padding-left: 5px;'>• Không đồng kiểm</li>
            <li style='padding-left: 5px;'>• <span style="font-weight: 600;text-transform: uppercase;">Vui lòng quay phim khi mở hàng</span></li>
            <li style='padding-left: 5px;'>• Một số sản phẩm có thể không thể hiện rõ do danh sách quá dài</li>
            <li><div style="font-size:10px;"><i>Thu COD: </i><b>${
              order?.payments?.find((e) => e.type === 'cod') ||
              order?.paymentType === 'cod'
                ? formatMoney(
                    order?.payments?.length > 0
                      ? sumBy(
                          order?.payments?.filter((e) => e.type === 'cod'),
                          (e: DynamicObjectType) => +e.amount,
                        )
                      : order?.total,
                    undefined,
                    undefined,
                    ' ',
                  )
                : 0
            } VND</b></div></li>
        </ul>
     </div>
     <div style="display:flex; border-top: 1px solid #000;">
     <div  style="padding: 2px 5px;font-size: 8px; text-align:left; flex:2;">
       <div style="font-size: 9px; line-height: 11px;">
       Người nhận: <b>${[
         `${order?.address?.firstName || ''} ${order?.address?.lastName || ''}`,
         compact([
           order?.address?.addressLine1,
           order?.address?.addressLine2,
           order?.address?.ward,
           order?.address?.district,
           order?.address?.province,
         ]).join(', '),
         order.address?.telephone,
       ].join(' | ')}</b>
       </div>
       ${
         order?.address?.what3words
           ? `<div style="display:flex; align-items:center;">
           <img height="15px" style="margin-right: 10px; margin-top: 2px;" src="https://res.cloudinary.com/hsv-search-image/image/upload/v1666241387/w3wlogo2_lkhs2l.png" />
       /// ${order?.address?.what3words}
       </div>`
           : ''
       }
    </div>
     </div>
    <div style="display: flex; border-top: 1px solid #000;">

    <div style="display:flex; padding: 0 3px 2px; flex: 2;">
    <div style="margin-right: 10px; margin-left: 5px;">
     <canvas style="height: 55px;"  id="customer-order-id-${
       order?.id
     }"></canvas>
     <div><b style="font-size:13px; margin-right: 10px;">${
       order?.deliveryCode
     }</b></div>
       </div>
             ${
               order?.sortCode
                 ? `<div style="width: 25%;display:flex; flex-direction: column; justify-content:center;  align-items:center;flex:1;font-size: 8px; text-align:left;">
            <canvas class="order-qrcode-img" id="qr-sortcode-${order?.id}"></canvas>
            <div style="font-size:9px;font-weight: 600;">
               ${order?.sortCode}
            </div>
         </div>`
                 : ''
             }
    </div>

    <div style="border-left: 1px solid #000; flex:1;padding: 2px 0px; padding-left: 3px;text-align:left;">
    <b style="font-size: 9px;">Chữ ký khách hàng</b>
 </div>
    </div>
      
      <div  style="text-align: left; flex:1; border-top:1px solid #000; padding: 6px 10px; flex:1;
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: 14px; max-height: 175px;">
         <div style="display:flex; font-size:10px; justify-content: space-between;">
            <div>
            <span>Tổng số lượng sản phẩm:</span> <b>${getTotalQuantiy(
              order?.items,
            )}</b></div>
            <div><span>Ngày xử lý đơn:</span> <span style="font-size: 11px;font-weight: 600;">${formatDateStr(
              order?.updatedAt,
            )}</span></div>
            
            
            </div>
         <div>
            <div style="
            overflow: hidden;
            text-overflow: ellipsis;
            line-height: 14px;
        ">
            ${order?.items
              ?.map(
                (e, index) =>
                  `<div>${index + 1}. ${compact([
                    e?.product?.productType?.detail?.find(
                      (e) => e?.langCode === 'vi',
                    )?.name ||
                      e?.product?.productType?.detail?.find(
                        (e) => e?.langCode === 'en',
                      )?.name ||
                      e?.product?.productType?.slug ||
                      '',
                    e.product?.detail?.[0]?.name,
                    e?.ItemDescription,
                    e?.VariantId,
                    e?.variantSku,
                  ]).join(', ')} x ${e.quantity}</div>`,
              )
              ?.join('')}
            </div>
         </div>
      </div>
               
      </div>
   </div>
   
   
</div>
</section>`,
    ),
  );
};

const getLabel = (order) => {
  console.log('order', order);
  if (order?.channel === 'shopee') return shopeeLabel(order);
  if (order?.channel === 'tiktokshops') return tiktokLabel(order);
  if (order?.shippingCarrier?.name === 'LEX') return LEXLabel(order);
  return '';
};

const tiktokLabel = (order) => `<section style="position:relative;">
<div style="width: 10cm; height: 15cm; overflow: hidden; text-overflow: ellipsis; font-size: 10px; border:1px solid #000; border-radius: 0px; display: flex;
 flex-direction: column;">
  <img src="${order?.shippingLabelUrl}" style="width: 100%;height: 100%; object-fit: contain" />
  <div style="position:absolute;
  bottom: 92px;
  left: 90px;
  background: white;
  font-weight: bold;
  font-size: 15px;
">${order?.orderNumber}</div>
 </div>
 </section>`;

const LEXLabel = (order) => {
  const channelLabelName = order?.shop?.shopName || order?.chainStore?.name;
  console.log('channelLabelName', channelLabelName);
  return `<section style="position:relative;">
  <div style="width: 10cm; position:relative; height: 15cm; overflow: hidden; text-overflow: ellipsis; font-size: 12px; display: flex;
   flex-direction: column; padding:5px 20px 20px 20px;">
    <div style="display:flex; border:1px solid #000; justify-content: space-between; ">
      <div
        style="width: 60px; min-width: 60px; flex:1; text-align:center; align-items: center; font-size: 9px; padding:0px 10px;font-weight: 500; border-right: 1px solid #000;">
        <img width="120px" src="/images/lexFullLogo.jpg"
          style="object-fit: contain;" />
        <div>Liên hệ CSKH 1900636828 KHI CẦN hỗ trợ https://lex.vn</div>
      </div>
      <div>
        <div style="flex:1;">
          <div
            style="display:flex; padding: 0px 10px; border-bottom: 1px solid #000; flex:1; align-items:center; justify-content:center; padding-right: 20px;">
            <div style="margin-right: 10px; font-size: 9px; font-weight: 600;">ĐỐI TÁC LẤY HÀNG</div>
            <img height="30px"
            style="height:30px;"
              src="/images/lexLogo.jpg" />
          </div>
          <div style="text-align:  center; font-size: 20px; padding:5px;"> Routine </div>
        </div>
      </div>
    </div>
    <div style=" text-align:center; display:flex; flex-direction:column; justify-content:center; align-items:center;">
      <canvas style="height: 100px;"  id="customer-order-id-${
        order?.id
      }"></canvas>
     <div><b style="font-size:13px; margin-left: 5px;">${
       order?.deliveryCode
     }</b></div>
    </div>
    <div style="display:flex; border:1px solid #000;">
      <div class="customer-info-here" style="flex:3; border-right: 1px solid #000;">
        <div style="padding: 2px 5px;font-size: 8px; text-align:left; flex:2;">
          <div style="font-size: 9px; line-height: 11px;"> Người nhận: ${`${order?.address?.firstName || ''}
            ${order?.address?.lastName || ''}`} <br />
            <img width="10px" height="10px" src="https://www.iconpacks.net/icons/1/free-phone-icon-1-thumb.png" />
            ${order.address?.telephone} <br />${compact([
              order?.address?.addressLine1,
              order?.address?.addressLine2,
              order?.address?.ward,
              order?.address?.district,
              order?.address?.province,
            ]).join(', ')}
          </div>
        </div>
        <div style="border-top:1px solid #000; padding-left: 5px;"> Người gửi: ROUTINE website </div>
      </div>
      <div style="flex:1; display:flex; align-items:center; flex-direction:column; font-size:9px; justify-content:center;" class="qr-code-hhx">
      <canvas class="order-qrcode-img" id="qr-routeCode-${order?.id}"></canvas>
      ${order?.shippingLabelData?.data?.routeCode}
      </div>
    </div>
    <div
      style="display:flex; text-align:center; border-right: 1px solid #000; border-left: 1px solid #000; border-bottom:1px solid #000;">
      <div style="flex:1; border-right: 1px solid #000;">${order?.orderNumber}</div>
      <div style="flex:1; border-right: 1px solid #000; padding: 5px 0px;">${order?.note || ''}</div>
      <div style="flex:1;">
        <div style="font-size:10px; padding: 5px 0px;">
          THU HỘ <br />
          ${
            order?.payments?.find((e) => e.type === 'cod') ||
            order?.paymentType === 'cod'
              ? formatMoney(
                  order?.payments?.length > 0
                    ? sumBy(
                        order?.payments?.filter((e) => e.type === 'cod'),
                        (e: DynamicObjectType) => +e.amount,
                      )
                    : order?.total,
                  undefined,
                  undefined,
                  ' ',
                )
              : 0
          } VND
        </div>
      </div>
    </div>
    <div style="border:1px dashed #000;margin-top: 2px; margin-bottom:2px;"></div>
    <div style="display: flex; flex:1; border:1px solid #000; height:210px;">
      <div style="width: 85px; border-right: 1px solid #000; position: relative;">
      <div style="display: flex;
    flex-direction: column;
    transform: rotate(90deg);
    align-items: center;
    justify-content: center;
    position: absolute;     top: 30%;
    left: -60%;">
      <canvas style="height: 70px;"  id="ordernumber-order-id-${
        order?.id
      }"></canvas>
      </div></div>
      <div style="flex:1;">
        <div style="border-bottom: 1px solid #000; flex:1;"> Ngày đặt: ${formatDateTime(
          order?.createdAt,
          'DD-MM-YYYY HH:mm',
        )} </div>
        <div>
          <div>
            <div style="
            overflow: hidden;
            text-overflow: ellipsis;
            line-height: 14px;
        ">
              ${order?.items
                ?.map(
                  (e, index) =>
                    `<div>${index + 1}. ${compact([
                      e?.product?.productType?.detail?.find(
                        (e) => e?.langCode === 'vi',
                      )?.name ||
                        e?.product?.productType?.detail?.find(
                          (e) => e?.langCode === 'en',
                        )?.name ||
                        e?.product?.productType?.slug ||
                        '',
                      e.product?.detail?.[0]?.name,
                      e?.ItemDescription,
                      e?.VariantId,
                      e?.variantSku,
                    ]).join(', ')} x ${e.quantity}</div>`,
                )
                ?.join('')}
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div style="display:flex; font-size: 10px; justify-content:space-between; position: absolute; top:0; bottom:0; left:0;right:0; transform:rotate(90deg) translateY(5.1cm); height: 100%; width: 15cm;">
      <div>${order?.deliveryCode}</div>
      <div>${order?.deliveryCode}</div>
      <div>${order?.deliveryCode}</div>
      <div>${order?.deliveryCode}</div>
    </div>
    
    
    
    <div style="display:flex; font-size: 10px;  justify-content:space-between; position: absolute; top:0; bottom:0; left:0;right:0; transform:rotate(-90deg) translateY(0cm); height: 100%; width: 15cm;">
      <div>${order?.deliveryCode}</div>
      <div>${order?.deliveryCode}</div>
      <div>${order?.deliveryCode}</div>
      <div>${order?.deliveryCode}</div>
    </div>
    
    <div style="display:flex;  font-size: 10px; justify-content:space-between; position: absolute; bottom:2.5px; left:0;right:0;   width: 100%;">
      <div style="flex:1; text-align:center;">${order?.deliveryCode}</div>
      <div style="flex:1; text-align:center;">${order?.deliveryCode}</div>
    </div>
  </div>
</section>`;
};

const shopeeLabel = (order) => {
  const channelLabelName = order?.shop?.shopName || order?.chainStore?.name;

  return `<section style="position:relative;">
<div style="width: 10cm; height: 15cm; overflow: hidden; text-overflow: ellipsis; font-size: 10px; border:1px solid #000; border-radius: 0px; display: flex;
 flex-direction: column;">
  <div style="display:flex;padding: 10px; ">
    <div style=" flex:1; text-align: center; display: flex; flex-direction: column; justify-content: space-between; height: 100%; ">
      <img height="60px"
        src="https://hsv-ecomm-production-bucket.s3.amazonaws.com/bbx/common/5c657006-3848-45ad-99db-b79dd456688f.webp"
        style="object-fit: contain; filter: brightness(0); margin: -10px auto;">
      <img height="30px"
        src="${
          LOGISTICS?.find(
            (e) =>
              e.logistics_channel_name ===
              order?.shippingInfo?.shipping_carrier,
          )?.logo || '/logistics/shopeeXpress.png'
        }"
        style="object-fit: contain; filter: brightness(0);margin: 0 auto;">
    </div>
    <div style="padding-left: 5px; flex:1; font-size: 11px;display:flex;  flex-direction:column; justify-content:center;">
      <svg id="shopee-id-${
        order?.shippingInfo?.tracking_number
      }" class="shopee-tracking-number barcode-img" />
      <div style="display: flex; flex:1; margin-top: 5px;">
        <div style="width: 80px; text-align:left;">Mã vận đơn:</div>
        <b>${order?.shippingInfo?.tracking_number}</b>
      </div>
      <div style="display: flex;">
        <div style="width: 80px; text-align:left;">Mã đơn hàng:</div>
        <b>${order?.orderNumber}</b>
      </div>
    </div>
  </div>
  <div
    style="display:flex; flex:1; flex-direction:column; padding-top: 6px; width: 100%; border-top: 1px dashed #000;">
    <div style="text-align:left; display:flex; padding: 0px; justify-content: space-between; font-size: 10px;">
      <div style="flex:1; padding: 0 10px 6px; border-right: 1px dashed #000;">
        <b>Từ:</b>
        <br />
        <div style='font-size: 8px;'>${channelLabelName} - 
          ${order?.location?.locationAddress}
          SĐT: ${order?.location?.phoneNumber}</div>
      </div>
      <div style="flex:1; padding: 0 10px 6px; ">
        <b>Đến:</b>
        <br />
        <div  style='font-size: 8px;'>${
          order?.shippingInfo?.recipient_address?.name ||
          `${order?.address?.firstName || ''} ${order?.address?.lastName || ''}`
        }
        ${order?.shippingInfo?.recipient_address?.full_address || order?.shippingInfo?.recipient_addr || ''}</div>
      </div>
    </div>
    <div style="border-top: 1px dashed #000;">
      <div style="font-size: 30px; font-weight: 900; text-align: center;">${
        order?.shippingInfo?.recipient_sort_code?.first_recipient_sort_code
      }</div>
    </div>

    <div style="display: flex; text-align: left; flex:1; border-top:1px dashed #000; padding: 6px 10px; flex:1;">

      <div style="font-size:10px; flex:3; border-right:1px dashed #000; padding-right: 10px;">
        <b>
          Nội dung hàng (Tổng SL sản phẩm: ${getTotalQuantiy(order?.items)})
        </b>

        <div style="display: flex; flex-direction: column; justify-content: space-between;">
          <div style="
            overflow: hidden;
            text-overflow: ellipsis;
            height: 120px;
            line-height: 10px;
            font-size: 8px;
        ">
        ${order?.items
          ?.map(
            (e, index) =>
              `<div>${index + 1}. ${compact([
                e?.product?.productType?.detail?.find(
                  (e) => e?.langCode === 'vi',
                )?.name ||
                  e?.product?.productType?.detail?.find(
                    (e) => e?.langCode === 'en',
                  )?.name ||
                  e?.product?.productType?.slug ||
                  '',
                e.product?.detail?.[0]?.name,
                e?.ItemDescription,
                e?.VariantId,
                e?.variantSku,
              ]).join(', ')} x ${e.quantity}</div>`,
          )
          ?.join('')}
          </div>
          <div style="font-size: 8px; padding-top: 3px; margin-top: 3px; border-top: 1px dashed #000;">
            Kiểm tra tên sản phẩm và đối chiếu Mã vận đơn/Mã đơn hàng
            trên ứng dụng Shopee trước khi nhận hàng (Lưu ý: Một số sản
            phẩm có thể bị ẩn do danh sách quá dài)
          </div>
        </div>
      </div>
      <div style="flex: 1; display: flex; flex-direction: column; justify-content: space-between;">
        <div style="border-bottom:1px dashed #000;text-align: center; padding-bottom: 5px; padding-left: 8px;">
          <canvas class="order-qrcode-img" id="qr-tracking-${order?.id}"></canvas>
        </div>
        <div style='text-align;center; font-size:20px; font-weight: 800; margin:auto;'></div>
        <div style="border-top:1px dashed #000; text-align: center; margin-top: 3px; ">
          ngày đặt hàng:
          <br />
          <b style="font-size: 10px; padding:0px 5px; text-align:center;">${formatDateTime(
            order?.createdAt,
            'DD-MM-YYYY HH:mm',
          )}</b>
        </div>
      </div>
    </div>

    <div style="padding: 0px; display:flex; border-top: 1px dashed #000;">
      <div style="padding: 5px;text-align:left; flex:1; ">
        <div style="font-size: 10px;">Tiền thu Người nhận:&nbsp;&nbsp;
          <br />
        </div>
        <b>
          <div style="font-size: 35px; margin-top: 5px; text-align:center;">${formatMoney(
            Number(order?.shippingInfo?.cod_amount),
            undefined,
            undefined,
            'VND',
          )}</div>
        </b>
      </div>
      <div style="flex:1;padding: 2px;  text-align:center;">
        <div>Khối lượng tối đa: ${formatMoney(
          order?.shippingInfo?.order_weight,
          undefined,
          undefined,
          'g',
        )}</div>
        <div style="border: 1px solid #000;  padding-bottom: 30px;margin:5px;">
          <b>Chữ ký người nhận</b>
          <div style="font-size: 8px;">Xác nhận hàng nguyên vẹn, không
            móp/méo, bể/vỡ</div>
        </div>
      </div>
    </div>
    <div style="font-size: 8.3px; padding-bottom: 2px; border-bottom: 1px dashed #000;">
      <b>Chỉ dẫn giao hàng:</b>Không đồng kiểm; <span style="font-weight: 600;text-transform: uppercase;">Vui lòng quay phim khi mở hàng;</span> Lưu kho tối đa 5 ngày
    </div>

    <div style="font-size: 9px; padding:2px;">
      <b>Tuyển dụng Tài xế/Điều phối kho SPX - Thu nhập 8-20 triệu - Gọi 1900 6885</b>
    </div>
  </div>
</div>



</section>`;
};

// <img height="60px" src="http://bwipjs-api.metafloor.com/?bcid=code128&text=${
//  order?.shippingInfo?.tracking_number
// }"
//  style="object-fit: contain;">
